'use strict';

module.exports = {
  HOURS_INDEX: 3,
  DAY_INDEX: 4,
  WEEK_INDEX: 5,
  MONTH_INDEX: 6,
  YEAR_INDEX: 7
};


// WEBPACK FOOTER //
// ./~/sugar-date/date/var/DateUnitIndexes.js